import { IEntityDataService } from "@pit/core-data";
import { IDtoArchive } from "@pit/frontend-model";
import { Observable } from "rxjs";

export interface IDtoArchiveEntityDataService extends IEntityDataService<IDtoArchive> {

    getItemsByShipmentNumberAndMandator$(mandator: string, shipmentNumber: string): Observable<IDtoArchive[]>;
    getItemsByShipmentNumberAndMandatorAsync(mandator: string, shipmentNumber: string): Promise<IDtoArchive[]>;

}
